import { NestedTableNodeTree, NodeTrees } from '../types';
import { createInitialCollapsedState, recordMerge } from './collapseState';

export const useCreateCollapseState = (collapseByDefault: boolean) => ({
  create: (src?: NodeTrees | NestedTableNodeTree[]) =>
    createInitialCollapsedState(src, collapseByDefault),
  merge: (src?: NodeTrees | NestedTableNodeTree[]) =>
    recordMerge(createInitialCollapsedState(src, collapseByDefault)),
});
